import merge from 'lodash/merge'
import { MERGE_ORGANIZATIONS } from '@/store/mutation-types'

export const namespaced = false
export const state = {
  organizations: {}
}
export const mutations = {
  [MERGE_ORGANIZATIONS](state, organizations) {
    state.organizations = merge({}, state.organizations, organizations)
  }
}
